import React from 'react';

import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import Button from '@material-ui/core/Button';
import { Paper } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Typography from '@material-ui/core/Typography';
import { Assignment } from '@material-ui/icons';

const useStyles = makeStyles({
  root: {
    paddingLeft: 20,
    paddingRight: 20,
    paddingTop: 10,
    paddingBottom: 10,
    borderRadius: 7,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
  },

  btnContainer: {
    paddingTop: 20,
    paddingBottom: 20,
  },

  fileInputContainer: {
    border: '1px solid #b4b4b4',
    borderRadius: 3,
    padding: 10,
  },
});

function GuidelineCircularsEdit() {
  const classes = useStyles();
  return (
    <>
      <Grid container alignItems="center">
        <Grid item sm={12}>
          <h2>Guidelines and Circulars</h2>
        </Grid>
      </Grid>
      {/* <Grid>
        <h3>Information</h3>
      </Grid> */}
      <Paper className={classes.root} elevation={4}>
        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <h3>Category</h3>
            <Select fullWidth variant="outlined" placeholder="-Select User Type-" value={1}>
              <MenuItem value={1}>
                <span>-Select Category-</span>
              </MenuItem>
              <MenuItem value={10}>Ten</MenuItem>
              <MenuItem value={20}>Twenty</MenuItem>
              <MenuItem value={30}>Thirty</MenuItem>
            </Select>
          </Grid>
          <Grid item xs={12} md={6}>
            <h3>
              Sub Category<span style={{ color: 'red' }}>*</span>
            </h3>
            <Select fullWidth variant="outlined" placeholder="-Select User Type-" value={1}>
              <MenuItem value={1}>
                <span>-Select - Subcategory-</span>
              </MenuItem>
              <MenuItem value={10}>Ten</MenuItem>
              <MenuItem value={20}>Twenty</MenuItem>
              <MenuItem value={30}>Thirty</MenuItem>
            </Select>
          </Grid>
        </Grid>
        {/* <br /> */}

        {/* <Grid>
        <h3>Information</h3>
      </Grid> */}

        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <h3>
              File<span style={{ color: 'red' }}>*</span>
            </h3>
            <div className={classes.fileInputContainer}>
              <input type="file" />
            </div>
          </Grid>
        </Grid>
        <Grid container spacing={2} className={classes.btnContainer}>
          <br />
          <Grid container item sm={12} md={12} justify="flex-end">
            <Button color="primary" variant="contained" className="mr-20" style={{ paddingLeft: 30, paddingRight: 30 }}>
              Save
            </Button>
            <Button variant="outlined" color="primary">
              Cancel
            </Button>
          </Grid>
        </Grid>
      </Paper>
    </>
  );
}

export default GuidelineCircularsEdit;
